import { useEffect } from 'react'

import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { autoSignIn } from '@store/auth'
import { queryStringtoObject } from '@utils'

interface IAuthAutoSignInRedirectProps {
  autoSignIn: typeof autoSignIn
  history: any
}

// Base component for testing
export const AuthAutoSignInRedirect: React.FC<IAuthAutoSignInRedirectProps> = ({
  autoSignIn: autoSignInAction,
  history,
}) => {
  const query: any = queryStringtoObject(history.location.search)

  useEffect(() => {
    if (query.token) {
      autoSignInAction(
        { token: query.token },
        { history, redirect: query.campaign_id && `/campaigns/${query.campaign_id}` },
      )
    }
  }, [])

  return null
}

// Connected component for production
const ConnectedAuthAutoSignInRedirect: React.FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  return (
    <AuthAutoSignInRedirect
      autoSignIn={(params, meta) => dispatch(autoSignIn(params, meta))}
      history={history}
    />
  )
}

export default ConnectedAuthAutoSignInRedirect
